<div class="modal-header">
    <h1 class="modal-title">{{ 'brapi-sync.title' | translate }}</h1>
</div>
<div class="container-fluid" style="overflow-y: auto; min-height: 100vh;">
    <router-outlet name="brapi-sync-outlet"></router-outlet>
</div>

